function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "40",
  height: "40",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), React.createElement("defs", null, React.createElement("path", {
  id: "b",
  d: "M0 0h34v24H0z"
})), React.createElement("g", {
  transform: "translate(3 8)",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "undoB",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#b"
})), React.createElement("path", {
  d: "M28.62 9.331C20.935.18 8.932-.428 1.308 7.643V2.968H0v6.537c0 .45.293.817.654.817h5.232V8.688H2.35c7.125-7.322 18.2-6.683 24.987 1.8 7.14 8.92 7.14 23.437 0 32.357L28.262 44c7.65-9.557 7.65-25.111 0-34.669z",
  fill: "#000",
  mask: "url(#undoB)"
}))));